// extracted by mini-css-extract-plugin
module.exports = {"blogs__footer":"styles_blogs__footer__EE_t5","blogs__link":"styles_blogs__link__8fRvN"};